import { AbstractWidgetComponent, ClientContextService, CommonBrowserStorageService, ContextChange, WidgetStyle } from '@sdbn/appclient';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CustomFilter, CustomFilterType } from 'src/tmc-common/model/custom-filter';
import { TranslationService } from '@sdbn/common';
import { TransportSelection } from 'src/tmc-yard/common/model/transport.model';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';


@Component({
  selector: 'app-transport-selection',
  templateUrl: './transport-selection.component.html',
  styleUrls: ['./transport-selection.component.scss']
})
export class TransportSelectionComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  TRANSPORT_SELECTION_KEY = 'transport-selection';

  transportSelection = new TransportSelection();

  filterFormGroup = new FormGroup({
    filterText: new FormControl(null, []),
    customFilter: new FormControl(-1, [])
  });

  filters: CustomFilter[] = [];
  filterSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private tmcContextService: TmcContextService,
    private clientContextService: ClientContextService
  ) {

    super();

    this.filterFormGroup.valueChanges.pipe(debounceTime(300)).subscribe(
      value => {
        this.transportSelection.filterText = value.filterText;
        this.transportSelection.customFilterId = value.customFilter;
        this.handleFilterChanged();
      }
    );
  }

  ngOnInit() {

    if (this.restoreTransportSelection()) {
      this.dashboardContext.setContextValue('transport-selection', this.transportSelection);
    }

    this.filterSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.filters = this.tmcContextService.getYardConfiguration().customFilters.filter(f => f.type === CustomFilterType.TRANSPORT_LIST);
      }
    });

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  storeTransportSelection() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.widgetIdentifier, this.TRANSPORT_SELECTION_KEY, JSON.stringify(this.transportSelection));
  }

  restoreTransportSelection(): boolean {
    const transportSelection = JSON.parse(this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.widgetIdentifier, this.TRANSPORT_SELECTION_KEY));
    if (transportSelection != null) {
      this.transportSelection = transportSelection;
      this.filterFormGroup.patchValue({
        filterText: this.transportSelection.filterText,
        customFilter: this.transportSelection.customFilterId
      });
      return true;
    }
    return false;
  }

  private handleFilterChanged() {

    this.storeTransportSelection();
    this.dashboardContext.setContextValue('transport-selection', this.transportSelection);

  }

  public switchScopeTrain() {
    this.transportSelection.scopeTrain = !this.transportSelection.scopeTrain;
    this.handleFilterChanged();
  }

  public switchScopeTrailer() {
    this.transportSelection.scopeTrailer = !this.transportSelection.scopeTrailer;
    this.handleFilterChanged();
  }

  public switchScopeSwapTrailer() {
    this.transportSelection.scopeSwapTrailer = !this.transportSelection.scopeSwapTrailer;
    this.handleFilterChanged();
  }

  public switchScopeSemiTruckTrailer() {
    this.transportSelection.scopeSemiTrailerTruck = !this.transportSelection.scopeSemiTrailerTruck;
    this.handleFilterChanged();
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
